export default {
  QualityScore: 'QualityScore/OverallQualityScore',
};
